import { render, staticRenderFns } from "./InformationDialog.vue?vue&type=template&id=0c815928&scoped=true"
import script from "./InformationDialog.vue?vue&type=script&lang=js"
export * from "./InformationDialog.vue?vue&type=script&lang=js"
import style0 from "./InformationDialog.vue?vue&type=style&index=0&id=0c815928&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c815928",
  null
  
)

export default component.exports